import { createFileRoute } from "@tanstack/react-router";

export { JobActivityPanel as JobDrawerActivityPanel } from "@/features/jobs/components/job-activity-panel";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/_drawer/activity",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
